import React, {useEffect, useState} from "react";
import {Grid, View} from "@aws-amplify/ui-react";
import LessonsList from "../../components/LessonsList";
import styles from './index.module.css';
import {parseHtmlString, getTitleColor} from "../../utils";
import {Outlet, useLoaderData, useOutletContext, useLocation, matchPath, useNavigation} from "react-router-dom";
import ItemsCollection from "../../components/ItemsCollection";
import GlobalAlert from "../../components/GlobalAlert";
import Loading from "../../components/Loading";
import LicenseWarning from "../../components/LicenseWarning";

const Lesson = () => {
  const [missingLicense, setMissingLicense] = useState(false);

  const {
    courseId = 0,
    lessonId = 0,
    lesson = {},
    error,
  } = useLoaderData();

  const location = useLocation();
  const {pathname = ""} = location || {};
  const matchLesson =
    matchPath("/corsi/:courseId/lezioni/:lessonId", pathname);
  const matchTopic =
    matchPath("/corsi/:courseId/lezioni/:lessonId/approfondimenti/:topicId", pathname);

  const {course = {}} = useOutletContext();
  const {lessons = []} = course || {};

  const {
    id = 0,
    title = "",
    description = "",
    topics = [],
    cover = ""
  } = lesson || {};

  const scrolledRef = React.useRef(false);

  useEffect(() => {
    if (window.sessionStorage.getItem("missing_license")) {
      setMissingLicense(true);
    } else {
      setMissingLicense(false);
    }

    if (!!matchLesson && !matchTopic) {
      setTimeout(() => {
        const element = document.getElementById("lesson");
        if (element) {
          element.scrollIntoView({block: "start", inline: "nearest", behavior: 'smooth'});
          scrolledRef.current = true;
        }
      }, 100);
    }
  }, [lessonId]);

  const titleClassNames = [styles.lessonTitle, getTitleColor(courseId)]

  const navigation = useNavigation();

  if (
    navigation.state === "loading" &&
    !!matchLesson &&
    !matchTopic
  ) {
    return <Loading/>
  }

  return (
    <Grid
      id="lesson"
      templateColumns={{base: "1fr", medium: "2fr 1fr", large: "4fr 1fr"}}
      templateRows={{base: "repeat(3, auto)", medium: "30vh auto"}}
      className={styles.mainGrid}
    >
      {
        !!error &&
        <GlobalAlert
          heading={error.toString()}
          variation="error"
        />
      }
      <View
        position="relative"
        className={styles.titleViewWrapper}
        backgroundImage={`url(${cover})`}
        columnSpan={[1, 1, 2, 2]}
      >
        <Grid
          templateColumns={{base: "1fr", large: "4fr 1fr"}}
          templateRows={{base: "auto", large: "30vh"}}
        >
          <View className={styles.lessonTitleWrapper}>
            <View className={styles.lessonTitleContainer}>
              <h2 className={titleClassNames.join(' ')}>
                {title}
              </h2>
            </View>
          </View>
        </Grid>
      </View>

      <View className={styles.contentViewWrapper}>
        {parseHtmlString(description)}
        {
          missingLicense &&
          <LicenseWarning/>
        }
      </View>

      <View className={styles.siderViewWrapper}>
        <LessonsList
          courseId={courseId}
          lessons={lessons}
          currentLessonId={id}
        />
      </View>

      {
        !!matchLesson &&
        <View
          className={styles.itemsCollectionViewWrapper}
          columnSpan={[1, 1, 2, 1]}
        >
          <ItemsCollection
            items={topics}
            courseId={courseId}
            lessonId={lessonId}
            backgroundColor="detail"
          />
        </View>
      }

      <View
        columnSpan={[1, 1, 2, 2]}
      >
        <Outlet
          context={{
            course: course,
            lesson: lesson,
          }}
        />
      </View>
    </Grid>
  )
}

export default Lesson;